export const getUserColor = (username: string): string => {
  const colors = [
    '#007bff', // niebieski
    '#28a745', // zielony
    '#dc3545', // czerwony
    '#ffc107', // żółty
    '#17a2b8', // cyjan
    '#6610f2', // fioletowy
    '#fd7e14', // pomarańczowy
    '#20c997', // turkusowy
    '#e83e8c', // różowy
    '#6f42c1' // indygo
  ]

  // Używamy sumy kodów ASCII liter nazwy użytkownika do wyboru koloru
  const sum = username.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
  return colors[sum % colors.length]
}
